import axios from 'axios';

window.axiosInstance = axios;

window.VITE_API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
